import AbstractComponent from './AbstractComponent';
import CartJS from 'shopify-cartjs';
class Product extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.handleChangeRadio = this.handleChangeRadio.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleCartRequestComplete = this.handleCartRequestComplete.bind(this);
  }

  initializeBeforeEvents() {
    this.ui.$radios.forEach(($radio) => {
      if ($radio.checked) this.handleChangeRadio({ currentTarget: $radio });
    });
  }

  getUI() {
    const ui = super.getUI();
    ui.$title = ui.$element.querySelector('.product__title');
    ui.$radios = [...ui.$element.querySelectorAll('.form__group--variants input[type=radio]')];
    ui.$form = ui.$element.querySelector('.form--product');
    ui.$submits = [...ui.$form.querySelectorAll('.form--product [type="submit"]')];
    ui.$submitPrice = ui.$form.querySelector('[type="submit"] .price');
    return ui;
  }

  events(listen) {
    const listener = listen ? 'addEventListener' : 'removeEventListener';
    const jqueryListener = listen ? 'on' : 'off';
    const { $radios, $form } = this.ui;
    $radios.forEach(($radio) => $radio[listener]('change', this.handleChangeRadio));
    $form[listener]('submit', this.handleFormSubmit);
    $(document)[jqueryListener]('cart.requestComplete', this.handleCartRequestComplete);
  }

  handleFormSubmit(event) {
    event.preventDefault();
    if (this.isLoading) return;
    this.isLoading = true;
    const { $radios, $submits } = this.ui;

    // Set loading state
    $submits.forEach(($submit) => {
      $submit.classList.add('is-loading');
      $submit.setAttribute('disabled', 'true');
    });

    // Add to cart
    const $radio = $radios.find(($radio) => $radio.checked);

    let variantId = null,
      sellingPlan = null;
    if ($radio.value.indexOf('//')) {
      const [id, plan] = $radio.value.split('//');
      variantId = parseInt(id, 10);
      sellingPlan = parseInt(plan, 10);
    } else {
      variantId = parseInt($radio.value, 10);
    }

    if (variantId) {
      CartJS.addItem(variantId, 1, sellingPlan ? { selling_plan: sellingPlan } : {});
    }
  }

  handleCartRequestComplete() {
    const { $submits } = this.ui;
    this.isLoading = false;
    $submits.forEach(($submit) => {
      $submit.classList.remove('is-loading');
      $submit.removeAttribute('disabled');
    });
  }

  handleChangeRadio(event) {
    try {
      const $price = event.currentTarget.closest('.variant').querySelector('.variant__price');
      this.ui.$submitPrice.innerHTML = $price.innerHTML;
    } catch (e) {
      // silent
    }
  }
}

export default Product;
